import { render, staticRenderFns } from "./OrderDetailDialog.vue?vue&type=template&id=c7e4f2dc&scoped=true"
import script from "./OrderDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailDialog.vue?vue&type=style&index=0&id=c7e4f2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e4f2dc",
  null
  
)

export default component.exports